export default {
  init($element) {
  },
  finalize($element) {
    $('.flexible-accordion').on('shown.bs.collapse', function (e) {
      let $clickedElement = $($(e.target).data('bs.collapse')._triggerArray);
      $clickedElement.children('.icon').text('-');
    });

    $('.flexible-accordion').on('hidden.bs.collapse', function (e) {
      let $clickedElement = $($(e.target).data('bs.collapse')._triggerArray);
      $clickedElement.children('.icon').text('+');
    });
  },
}



// WEBPACK FOOTER //
// ./scripts/partials/flexible/accordion.js